/* Desktop contact fields fade in as they enter the viewport; fields in the
   second grid column trail by 100ms. The hidden state (data-field-reveal) is
   applied here rather than in the markup, so without this script every field
   stays visible. The CSS only hides fields at 990px and up. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-field-visible', '');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  function init(scope) {
    scope.querySelectorAll('.cfn__grid').forEach(function (grid) {
      var fields = grid.querySelectorAll('.cfn__field');
      if (!fields.length) return;

      var firstLeft = fields[0].offsetLeft;
      fields.forEach(function (field) {
        if (field.hasAttribute('data-field-reveal')) return;
        if (field.offsetLeft > firstLeft) field.style.setProperty('--field-reveal-delay', '100ms');
        field.setAttribute('data-field-reveal', '');
        observer.observe(field);
      });
    });
  }

  init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
